import React from "react";
import { MessageCircle } from "lucide-react";

interface RegisterSidebarProps {
  stepTitles: string[];
  highLevelIndex: number;
  desktopProgress: number;
}

export const RegisterSidebar: React.FC<RegisterSidebarProps> = ({
  stepTitles,
  highLevelIndex,
  desktopProgress,
}) => {
  return (
    <aside className="hidden lg:flex lg:w-[320px] lg:flex-col lg:justify-between lg:border-r lg:border-gray-200 lg:bg-gradient-to-b lg:from-purple-700 lg:to-purple-900 lg:p-6 lg:text-white">
      <div>
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
            <MessageCircle className="h-5 w-5" />
          </div>
          <div>
            <h2 className="text-base font-semibold">Cadastro Easyfit</h2>
            <p className="text-xs text-purple-100">Fluxo guiado e seguro</p>
          </div>
        </div>

        <div className="mb-5">
          <div className="mb-2 flex items-center justify-between text-xs text-purple-100">
            <span>Progresso</span>
            <span>{desktopProgress}%</span>
          </div>
          <div className="h-2 rounded-full bg-white/20">
            <div
              className="h-2 rounded-full bg-white transition-all duration-500"
              style={{ width: `${desktopProgress}%` }}
            />
          </div>
        </div>

        <ul className="space-y-2">
          {stepTitles.map((title, idx) => {
            const active = idx + 1 <= highLevelIndex;
            return (
              <li
                key={title}
                className={`rounded-lg px-3 py-2 text-sm transition ${
                  active ? "bg-white/20 font-medium" : "text-purple-100"
                }`}
              >
                {idx + 1}. {title}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-xl bg-emerald-500/95 p-3 text-xs leading-relaxed text-emerald-50 shadow-sm">
        <p className="font-semibold">Ambiente seguro</p>
        <p>Processado via PagBank e com dados sensíveis protegidos.</p>
      </div>
    </aside>
  );
};

export default RegisterSidebar;

